import { AxiosService } from './../../../services/axios.service'
import * as config from 'config'

/**
 * Redefines the user's password
 * @param {string} userId The user's identifier
 * @param {string} code The password reset token (code)
 * @param {string} password The new user's password
 */
const redefinePassword = (userId, code, password) =>
	AxiosService.post(`identidade/redefinir-senha`, {
		userId,
		code,
		password
	})

export { redefinePassword }
